export default {
  nl: {
    appointmentSection: {
      bookingText: 'De afspraak wordt ingepland',
      moment: 'Een klein moment alstublieft...',
      hour: 'uur',
      mobileHeader: 'Selecteer een afspraakmogelijkheid',
      selection: 'Selectie',
      date: 'Datum en tijdslot',
      route: 'Route',
      separator: 'tussen',
      confirmAppointment: 'Bevestig afspraak',
    },
    appointment: {
      title: 'Wanneer kan de monteur het beste bij je langskomen?',
      goBack: 'Vragen',
      editTitle: 'Afspraak wijzigen',
      loadingQuestions: 'De vragen worden geladen ...',
      savingAnswers: 'De antwoorden worden opgeslagen ...',
    },
    appointmentLoading: {
      selectingBestExpert: 'Beste monteurs in de buurt selecteren ...',
      calculatingEcoRoute: 'Milieuvriendelijke routes berekenen ...',
    },
    slots: {
      showPreviousSlots: 'Laat vorig tijdslot zien',
      showNextSlots: 'Laat volgend tijdslot zien',
      loadMoreSlots: 'Laad meer',
      bestSlot: 'De beste keuze voor het milieu!',
      selectedSlots: 'Jouw geselecteerde tijdslot',
      selectedAppointmentTimeRange: '{{startTime}} - {{endTime}} uur',
      ariaLabelSlot: 'Tijdslot tussen {{startTime}} en {{endTime}}, duurzaamheidsscore is {{grade}} van de 3',
    },
    noSlotsPopup: {
      confirmButton: 'Oké, ik begrijp het'
    },
    noslots: {
      alertInfo: 'Je kan maar in één week beschikbaarheid opgeven. Lukt deze week niet, klik dan onderaan op ‘>’ .',
      alertError: 'Er is iets fout gegaan, wij konden onze beschikbare tijdsloten niet laden.',
      alertButton: 'Probeer het opnieuw',
      thanksTitle: 'Bedankt!',
      entireDay: 'Hele dag',
      scheduleAutoBtn: 'Bevestig beschikbaarheid',
    },
  },
  en: {
    appointmentSection: {
      bookingText: 'The appointment is being made',
      moment: 'One moment please...',
      hour: '',
      mobileHeader: 'Select a date',
      selection: 'Selection',
      date: 'Date and time',
      route: 'Route',
      separator: 'between',
      confirmAppointment: 'Confirm appointment',
    },
    appointment: {
      title: 'When is the best time for the technician to visit you?',
      goBack: 'Questions',
      editTitle: 'Change appointment',
      loadingQuestions: 'Loading questions ...',
      savingAnswers: 'Saving answers...',
    },
    appointmentLoading: {
      selectingBestExpert: 'Selecting the best technician around you',
      calculatingEcoRoute: 'Calculating environmentally friendly routes ...',
    },
    slots: {
      showPreviousSlots: 'Show previous Slots',
      showNextSlots: 'Show next Slots',
      loadMoreSlots: 'Load more',
      bestSlot: 'The best choice for the environment!',
      selectedSlots: 'Your selected time slot',
      selectedAppointmentTimeRange: '{{startTime}} - {{endTime}}',
      ariaLabelSlot: 'Timeslot between {{startTime}} and {{endTime}}, eco grade score is {{grade}} out of 3',
    },
    noSlotsPopup: {
      confirmButton: 'Ok, I understand'
    },
    noslots: {
      alertInfo: "You can only select dates in one week. If the current week is not possible, click '>' for next week.",
      alertError: "Something went wrong, we couldn't load our available time slots.",
      alertButton: 'Please try again',
      thanksTitle: 'Thanks!',
      entireDay: 'Entire day',
      scheduleAutoBtn: 'Confirm availability',
    }
  }
};
